// extracted by mini-css-extract-plugin
export var box = "_1r-1";
export var checked = "_1r-2";
export var descriptionSpacer = "_1r-9";
export var disabled = "_1r-3";
export var icon = "_1r-6";
export var input = "_1r-0";
export var labelSpacer = "_1r-8";
export var medium = "_1r-5";
export var small = "_1r-4";
export var text = "_1r-7";